import { makeStyles } from 'tss-react/mui'
import { Theme, alpha } from '@mui/material/styles'
import { CHAT_ON_GRADIENT } from '../chatColors'

export const useStyles = makeStyles()((theme: Theme) => ({
  trigger: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    backgroundColor: 'transparent',
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    border: 'none',
    padding: 0,
    flexShrink: 0,
    '& svg': {
      fontSize: 14,
      color: CHAT_ON_GRADIENT,
    },
    '&:hover': {
      backgroundColor: alpha(theme.palette.text.white, 0.15),
    },
  },
  triggerActive: {
    backgroundColor: alpha(theme.palette.text.white, 0.25),
  },
  paper: {
    width: theme.spacing(22.125),
    marginTop: theme.spacing(0.5),
    padding: `${theme.spacing(0.625)} ${theme.spacing(0.125)}`,
    borderRadius: 12,
    border: `1px solid ${theme.palette.dividerV2.main}`,
    backgroundColor: theme.palette.bgPrimary.main,
    boxShadow: `0 0 20px ${alpha(theme.palette.common.black, 0.18)}`,
  },
  list: {
    padding: 0,
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: `${theme.spacing(1.25)} ${theme.spacing(2)}`,
    minHeight: 'unset',
    '&:hover': {
      backgroundColor: theme.palette.bgV2.main,
    },
  },
  itemIcon: {
    width: theme.spacing(2.25),
    height: theme.spacing(2.25),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& svg': {
      fontSize: 12,
      color: theme.palette.labraIcon.main,
    },
  },
  itemLabel: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '16px',
    color: theme.palette.labraText.tertiary,
    whiteSpace: 'nowrap',
  },
}))
